<template>
  <div class="contact-page pattern-bg">
    <Contact />
  </div>
</template>

<script>
import Contact from '@/components/home/Contact.vue'

export default {
  name: 'ContactView',
  components: {
    Contact
  }
}
</script>

<style scoped>
.pattern-bg {
  background-color: rgba(142, 202, 230, 0.1) !important;
}

.contact-page {
  background: #f8f9fa;
}
</style>
